<template>
  <div class="teacher-reports">
    <div class="page-header">
      <h1>学习报告</h1>
      <p>班级学习报告生成页面，开发中...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeacherReports'
}
</script>

<style lang="less" scoped>
.teacher-reports {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  
  h1 {
    margin: 0 0 16px 0;
    color: #2c3e50;
  }
  
  p {
    color: #7f8c8d;
    margin: 0;
  }
}
</style>
